export const setProfile = (profile) => {
  if (profile) {
    localStorage.setItem('profile', JSON.stringify(profile));
  }
};

export const getProfile = () => {
  const profile = localStorage.getItem('profile');
  return {
    profile: profile ? JSON.parse(profile) : null
  };
};

export const removeProfile = () => {
  localStorage.removeItem('profile');
};
